const SvgCircle = (props) => (
  <svg width={16} height={16} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <circle cx="10" cy="10" r="6.75" stroke="#011533" strokeWidth="1.5" />
  </svg>
);

export default SvgCircle;
